import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./Retos.css";

export default function RetosHome() {
  const navigate = useNavigate();

  const retos = useMemo(() => ([
    {
      id: "reto1",
      title: "Diseña los casos de prueba necesarios para un Login",
      meta: "Manual · Fácil · 15 min",
      tags: ["Manual", "Fácil"],
      summary: "Piensa como un QA y cubre validaciones, seguridad y UX.",
      path: "/retos/reto1",
    },
    {
      id: "reto2",
      title: "Valida URLs de endpoints y comprueba la respuesta",
      meta: "API · Media · 25 min",
      tags: ["API", "Media"],
      summary: "Construye rutas correctas y verifica que el endpoint devuelve lo esperado.",
      path: "/retos/reto2",
    },
    {
      id: "reto3",
      title: "Crea un test E2E para un carrito de compra",
      meta: "Automation · Media · 35 min",
      tags: ["Automation", "Media"],
      summary: "Automatiza y toma decisiones que reduzcan flakiness.",
      path: "/retos/reto3",
    },
  ]), []);

  const totalMinutes = retos.reduce((acc, reto) => {
    const minutes = Number.parseInt(reto.meta.match(/(\d+)/)?.[1] || "0", 10);
    return acc + minutes;
  }, 0);

  return (
    <div className="dash-page retos-page">
      <div className="retos-container">
        <div className="dash-hero retos-hero">
          <button
            className="dash-btn ghost roadmap"
            onClick={() => navigate("/dashboard")}
            style={{ marginBottom: 12 }}
          >
            ← Volver al dashboard
          </button>

          <div>
            <h1>Retos QA</h1>
            <p className="muted">
              Practica con el mismo lenguaje visual de la ruta de estudio, pero en modo misión.
            </p>

            <div className="dash-quick">
              <div className="quick-card">
                <div className="quick-title">Retos activos</div>
                <div className="quick-value">{retos.length}</div>
                <div className="muted small">Manual, API y Automation</div>
              </div>

              <div className="quick-card">
                <div className="quick-title">Recomendado</div>
                <div className="quick-value small">Empieza por Login Test Designer</div>
                <div className="muted small">La forma más rápida de activar mentalidad QA</div>
              </div>

              <div className="quick-card">
                <div className="quick-title">Duración total</div>
                <div className="quick-value">{totalMinutes} min</div>
                <div className="muted small">Puedes hacerlos en orden o saltar al que quieras</div>
              </div>
            </div>
          </div>
        </div>

        <div className="retos-shell">
          <div className="retos-shell-head">
            <div className="muted">Elige tu siguiente práctica</div>
            <div className="muted">Completa las 3 para mejorar tus skills</div>
          </div>

          <div className="reto-grid">
            {retos.map((r, index) => (
              <div key={r.id} className="reto-card">
                {index !== 0 && <div className="rm-arrow reto-arrow">➜</div>}

                <div className="reto-card-inner">
                  <div>
                    <div className="reto-card-top">
                      <div className="reto-index">0{index + 1}</div>
                      <div className="reto-title-block">
                        <div className="reto-title">{r.title}</div>
                        <div className="muted small">{r.meta}</div>
                      </div>
                    </div>

                    <div className="reto-summary muted">{r.summary}</div>

                    <div className="reto-tags">
                      {r.tags.map((t) => (
                        <span
                          key={t}
                          className={`pill ${
                            t === "Manual" || t === "API" || t === "Automation" || t === "Fácil"
                              ? "pill-green"
                              : "pill-gray"
                          }`}
                        >
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div className="reto-card-bottom">
                    <button className="reto-btn" onClick={() => navigate(r.path)}>
                      Empezar reto →
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
